<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">{{ $t('auto.stringFormatterTrimTrimMode') }}</div>
        <a-radio-group v-model="clone.trim.mode">
            <a-radio value="both">{{ $t('auto.stringFormatterTrimBothSides') }}</a-radio>
            <a-radio value="start">{{ $t('auto.stringFormatterTrimStartOnly') }}</a-radio>
            <a-radio value="end">{{ $t('auto.stringFormatterTrimEndOnly') }}</a-radio>
        </a-radio-group>
        <small class="description">
            {{ $t('auto.stringFormatterTrimSelectWhichPartsOfTheTextShouldHaveWhitespaceRemoved') }}
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";

const log = log2("StringFormatterTrim");
export default {
    name: "StringFormatterTrim",
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.trim",
            value: "",
            trim: {
                mode: "both",
            },
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 